import { Component, ElementRef, OnInit } from '@angular/core';
import { InceptionService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-mobile-app-promo',
  templateUrl: 'mobile-app-promo.component.html',
})
export class MobileAppPromoComponent implements OnInit {
  constructor(
    private inceptionService: InceptionService,
    private elementRef: ElementRef,
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.inceptionService.panelAccordion(this.elementRef);
      this.inceptionService.init();
    });
  }
}
